<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-row>
          <a-col :span="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="描述"
              hasFeedback
            >
              <a-input
                placeholder="请输入描述"
                id="description"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['description', { rules: [{ required: true, message: '请输入描述！' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="sql"
              hasFeedback
            >
              <a-input
                placeholder="请输入sql"
                id="sql"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['sql', { rules: [{ required: true, message: '请输入sql！' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="是否默认"
            >
              <a-radio-group :disabled="!isEdit" v-decorator="['isDefault', { rules: [{ required: true, message: '请输入是否默认！' }] }]">
                <a-radio :value="true">
                  是
                </a-radio>
                <a-radio :value="false">
                  否
                </a-radio>
              </a-radio-group>
              <!--              <a-switch default-checked :disabled="!isEdit" v-decorator="['isDefault', { rules: [{ required: true, message: '请输入是否默认！' }] }]" />-->
              <!--              <a-input-->
              <!--                placeholder="请输入是否默认"-->
              <!--                id="isDefault"-->
              <!--                :disabled="!isEdit" v-decorator="['isDefault', { rules: [{ required: true, message: '请输入是否默认！' }] }]"/>-->
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item :wrapper-col="{ span: 12, offset: 5 }" v-if="isEdit && $auth('datapermission.modifySql')">
              <a-button type="primary" html-type="submit" style="margin-right:10px;">
                提交
              </a-button>
              <a-button style="margin-right:10px;" @click="cancel">
                取消
              </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'

import { getSqlInfo, insertSql } from '@/api/sql'

export default {
  name: 'EditSql',
  mounted () {

  },
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    }
  },
  components: {
    baseModal
  },
  data () {
    return {
      tableId: null,
      title: '操作',
      width: 600,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'sql' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }

    }
  },
  methods: {
    setTableId (id) {
      this.tableId = id
    },
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if ((this.type === this.$sysInfo.MODAL_MODIFY) || (this.type === this.$sysInfo.MODAL_VIEW)) {
        if (flag) {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              description: this.model.description,
              sql: this.model.sql,
              isDefault: this.model.isDefault
            })
          })
        }
      }
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...this.model, ...value }
          params.tableId = this.tableId
          if (this.type === this.$sysInfo.MODAL_ADD) {
            delete params.id
            insertSql(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            insertSql(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          }
        }
      })
    },
    // 获取当前的model详情
    getModelInfo () {
      this.infoLoading = true
      getSqlInfo().then(res => {
        if (res.status === 0) {
          this.form.setFieldsValue({
            description: this.model.description,
            sql: this.model.sql,
            isDefault: this.model.isDefault
          })
          this.infoLoading = false
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    },
    handleChange () {

    },
    // 清空表单
    formClear () {
      this.form.setFieldsValue({ description: '', sql: '', isDefault: '' })
    },
    cancel () {
      this.formClear()
      this.open(false)
    }
    // 获取select列表

  }
}
</script>

<style scoped>

</style>
